import { FunctionComponent, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import {
  Box,
  Divider,
  Link,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { routes } from '@routes';
import { LoadingButton } from '@mui/lab';
import { useAuth } from '@context/auth';
import { PasswordInput } from '@components/ui/input/password-input';

export const LoginForm: FunctionComponent = () => {
  const emailRef = useRef<HTMLInputElement | null>(null);
  const passwordRef = useRef<HTMLInputElement | null>(null);
  const {
    errors,
    login: { isLoading, mutate: loginMutation },
  } = useAuth();

  const handleClick = () => {
    loginMutation({
      loginDto: {
        email: emailRef.current?.value ?? '',
        password: passwordRef.current?.value ?? '',
      },
    });
  };

  const emailError = errors?.find(({ field }) => field === 'email');
  const passwordError = errors?.find(({ field }) => field === 'password');

  return (
    <Stack spacing={2.5}>
      <TextField
        error={Boolean(emailError)}
        inputRef={emailRef}
        name="email"
        label="Email address"
        helperText={emailError?.message}
      />
      <PasswordInput
        error={Boolean(passwordError)}
        name="password"
        label="Password"
        inputRef={passwordRef}
        helperText={passwordError?.message}
      />
      <LoadingButton
        fullWidth
        size="large"
        type="submit"
        variant="contained"
        onClick={handleClick}
        loading={isLoading}
      >
        Continue
      </LoadingButton>
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="space-between"
        sx={{ py: 1.5 }}
        spacing={1.5}
      >
        <Link
          component={NavLink}
          variant="subtitle2"
          underline="hover"
          to={routes.forgotPassword}
        >
          Reset password
        </Link>
        <Divider variant="middle" flexItem sx={{ my: '30px!important' }} />

        <Box marginTop="0!important">
          <Typography variant="button" textTransform="none" fontWeight="400">
            Don't have an account?{' '}
          </Typography>
          <Link
            component={NavLink}
            variant="subtitle2"
            underline="hover"
            to={routes.signUp}
            marginTop={0}
          >
            Sign Up
          </Link>
        </Box>
      </Stack>
    </Stack>
  );
};
